<template>
  <div v-if="componentName">
    <AppLoading class="loading" />
    <component :is="componentName"></component>
  </div>
</template>
<script>
import AppLoading from '@/components/app/loading/loading.vue'
import Activity1 from './components/activity-1.vue'
import Activity2 from './components/activity-2.vue'
import Activity3 from './components/activity-3.vue'
export default {
  components: {
    AppLoading,
    Activity1,
    Activity2,
    Activity3
  },
  computed: {
    componentName() {
      return this.$route.query.componentName
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
